import { render, staticRenderFns } from "./AccountGoogle.vue?vue&type=template&id=0c38c7bf&scoped=true"
import script from "./AccountGoogle.vue?vue&type=script&lang=js"
export * from "./AccountGoogle.vue?vue&type=script&lang=js"
import style0 from "./AccountGoogle.vue?vue&type=style&index=0&id=0c38c7bf&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38c7bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c38c7bf')) {
      api.createRecord('0c38c7bf', component.options)
    } else {
      api.reload('0c38c7bf', component.options)
    }
    module.hot.accept("./AccountGoogle.vue?vue&type=template&id=0c38c7bf&scoped=true", function () {
      api.rerender('0c38c7bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/AccountGoogle.vue"
export default component.exports